import React from 'react';
import ServicePage from './ServicePage';

export default function GreenlineBasements() {
  return (
    <ServicePage
      category="basement"
      eyebrow="04 · Basements"
      title={<>Finished <em className="not-italic" style={{ color: 'var(--gl-primary)' }}>basements.</em></>}
      intro="The square footage is already there. We turn the dark, unused level of your home into the room you actually live in."
      description="Family rooms, media lounges, home offices, gyms, guest suites, and play spaces — engineered for comfort and built to code. We handle framing, insulation and moisture control, electrical and lighting, egress, drywall, flooring, and the finish carpentry that ties it all together. The result is a warm, dry, daylight-bright space that adds real living area and value to your home."
    />
  );
}
